export const ActivityCardsCarousel = (function () {
  let swiperInstance, prevButton, nextButton = null;
  let SELECTORS = null;

  function initSwiper() {
    const refContainer = document.querySelector(SELECTORS.refContainer); 
    const swiperWrapper = document.querySelector(SELECTORS.swiperWrapper);
    prevButton = document.querySelector(SELECTORS.prevButton);
    nextButton = document.querySelector(SELECTORS.nextButton);

    if (!refContainer || !swiperWrapper || !prevButton || !nextButton) {
      console.error('Required elements not found');
      return null;
    }    
    
    const refRect = refContainer.getBoundingClientRect();
    const offsetBefore = refRect.left;

    // Initialize Swiper
    const swiper = new Swiper(SELECTORS.swiper, {
      slidesPerView: "auto",
      spaceBetween: 16,
      freeMode: false,
      slidesOffsetBefore: offsetBefore,
      slidesOffsetAfter: 16,
      navigation: {
        nextEl: SELECTORS.nextButton,
        prevEl: SELECTORS.prevButton,
      },
      watchOverflow: true,
    });

    swiperInstance = swiper;

    // Set initial state of buttons
    updateButtonsState();

    // Add event listeners to update button states when slides change
    swiper.on('slideChange', updateButtonsState);
    
    // Add resize event listener separately
    window.addEventListener('resize', () => {
      const newOffsetBefore = refContainer.getBoundingClientRect().left;
      // Check if Swiper instance exists and has a method to update params
      if (swiper && swiper.params) {
        swiper.params.slidesOffsetBefore = newOffsetBefore;
        swiper.update(); // Refresh Swiper
      }
    });

    return swiper;
  }

  // Function to update button states
  function updateButtonsState() {
    if (!prevButton || !nextButton) return;
    
    prevButton.style.opacity = swiperInstance.isBeginning ? '0.5' : '1';
    prevButton.style.pointerEvents = swiperInstance.isBeginning ? 'none' : 'auto'; 

    //nextButton.style.opacity = swiperInstance.isEnd ? '0.5' : '1';
    ////nextButton.style.pointerEvents = swiperInstance.isEnd ? 'none' : 'auto';
    // Get Swiper's max translate position
    const maxTranslate = swiperInstance.maxTranslate();
    const currentTranslate = swiperInstance.translate;

    if (currentTranslate <= maxTranslate + 5) { // buffer of 5 to prevent minor calculation errors.
      nextButton.style.opacity = '0.5';
      nextButton.style.pointerEvents = 'none';
    } else {
      nextButton.style.opacity = '1';
      nextButton.style.pointerEvents = 'auto';
    }
  }

  // Public methods
  return {
    init: function(selectors) {
      SELECTORS = selectors;

      document.addEventListener('DOMContentLoaded', function() {
        const swiperWrapper = document.querySelector(SELECTORS.swiperWrapper);
        swiperWrapper.style.gap = '0';

        // Initialize swiper
        initSwiper();
      });
    }
  };
})();